'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _ParticleEmitter = require('../../../../components/animations/ParticleEmitter');

var _ParticleEmitter2 = _interopRequireDefault(_ParticleEmitter);

require('./Trophy.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Trophy = function Trophy(props) {
    return _react2.default.createElement(
        'div',
        { className: 'Trophy' },
        _react2.default.createElement(_Icon2.default, { name: 'payment-trophy' }),
        _react2.default.createElement(
            _ParticleEmitter2.default,
            {
                stopAfter: 35,
                particleFrequency: 7,
                initalVelocityX: { min: -1.5, max: 1.5 },
                initalVelocityY: { min: -6, max: -4 } },
            _react2.default.createElement(_Icon2.default, { name: 'payment-star' })
        )
    );
};

exports.default = Trophy;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/payment/success/Trophy.js
// module id = 2066
// module chunks = 0